export const isEmpty = (obj: object) => {
	return (typeof obj === "object") && Object.keys(obj).length === 0
}

export const getDataAttributes = (props:any) => {
	const data:{ [key: string]: string; } = {};
	for (const p in props) {
		if (p.includes(`data-`) && Object.hasOwnProperty.call(props, p)) {
			data[p] = props[p];
		}
	}
	return data;
};